import notification from '@/ApiConstance/toast'
import { api } from '../index'

export default {
  async createDriveLink(payload) {
    return await api.post('/storelmsdrive', payload).then(() => {
      notification.toast('SuccessFully Added Drive Link', 'success')
    })
  },
  async allDriveLink() {
    return await api.get('/getalllmsdrive')
  },

  async updateDriveLink(payload, id) {
    return await api.put(`/updatelmsdrive/${id}`, payload).then(() => {
      notification.toast('SuccessFully Updated Drive Link', 'success')
    })
  },

  async deleteDriveLink(id) {
    return await api.delete(`/deletelmsdrive/${id}`)
  },
}
